import React from 'react';
import DashMascot from '../components/Common/DashMascot';

const s = {
  hero: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '80px 24px 60px',
    display: 'flex',
    alignItems: 'center',
    gap: '60px',
  },
  left: { flex: 1 },
  tag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 18px',
    background: 'var(--teal-light)',
    color: 'var(--teal-dark)',
    borderRadius: 'var(--radius-pill)',
    fontSize: '15px',
    fontWeight: 700,
    marginBottom: '20px',
    border: '1px solid rgba(29,156,156,0.25)',
    letterSpacing: '0.01em',
  },
  h1: {
    fontSize: '48px',
    fontWeight: 800,
    color: 'var(--navy)',
    lineHeight: '1.15',
    marginBottom: '18px',
    letterSpacing: '-0.5px',
  },
  h1Accent: {
    color: 'var(--teal)',
  },
  desc: {
    fontSize: '17px',
    color: 'var(--text-secondary)',
    lineHeight: '1.75',
    maxWidth: '480px',
    marginBottom: '36px',
  },
  ctaRow: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  ctaPrimary: {
    padding: '13px 28px',
    background: 'var(--teal)',
    color: '#fff',
    borderRadius: 'var(--radius-btn)',
    fontSize: '15px',
    fontWeight: 600,
    transition: 'background 0.15s',
  },
  ctaSecondary: {
    padding: '13px 28px',
    background: 'var(--teal-dark)',
    color: '#ffffff',
    borderRadius: 'var(--radius-btn)',
    fontSize: '15px',
    fontWeight: 700,
    border: 'none',
    transition: 'all 0.18s',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(29, 156, 156, 0.28), 0 1px 2px rgba(0,0,0,0.05)',
    letterSpacing: '0.01em',
  },
  right: {
    flex: '0 0 420px',
  },
  visual: {
    background: 'linear-gradient(160deg, #1a5a5e 0%, #0d4f52 50%, #0a3a3f 100%)',
    borderRadius: '20px',
    padding: '24px',
    boxShadow: '0 16px 48px rgba(10, 58, 63, 0.30), 0 0 0 1px rgba(79, 209, 197, 0.10)',
    position: 'relative',
    overflow: 'hidden',
    minHeight: '420px',
    display: 'flex',
    flexDirection: 'column',
  },
  visualGrid: { display: 'none' },
  visualGlow: { display: 'none' },
  visualHeader: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '18px',
    paddingBottom: '14px',
    borderBottom: '1px solid rgba(79, 209, 197, 0.18)',
  },
  visualLogo: {
    width: '40px', height: '40px',
    borderRadius: '10px',
    background: 'rgba(79, 209, 197, 0.12)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    border: '1px solid rgba(79, 209, 197, 0.22)',
  },
  visualTitle: {
    fontSize: '18px',
    fontWeight: 800,
    color: '#ffffff',
    letterSpacing: '-0.01em',
    lineHeight: 1.15,
  },
  visualSub: {
    color: 'rgba(255, 255, 255, 0.70)',
    fontSize: '11.5px',
    marginTop: '2px',
    fontWeight: 500,
  },
  visualStatus: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    borderRadius: '999px',
    background: 'rgba(74, 222, 128, 0.14)',
    border: '1px solid rgba(74, 222, 128, 0.32)',
    color: '#86efac',
    fontSize: '10.5px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  statusDot: {
    width: '6px', height: '6px',
    borderRadius: '50%',
    background: '#4ade80',
    boxShadow: '0 0 0 3px rgba(74, 222, 128, 0.25)',
  },
  chatPreview: {
    position: 'relative',
    zIndex: 1,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '18px',
  },
  bubbleUser: {
    alignSelf: 'flex-end',
    maxWidth: '78%',
    padding: '10px 14px',
    borderRadius: '14px 4px 14px 14px',
    background: 'rgba(79, 209, 197, 0.18)',
    color: '#ffffff',
    fontSize: '12.5px',
    fontWeight: 500,
    border: '1px solid rgba(79, 209, 197, 0.28)',
  },
  bubbleBot: {
    alignSelf: 'flex-start',
    maxWidth: '88%',
    padding: '12px 14px',
    borderRadius: '4px 14px 14px 14px',
    background: 'rgba(10, 42, 47, 0.55)',
    color: 'rgba(255, 255, 255, 0.90)',
    fontSize: '12px',
    lineHeight: 1.6,
    border: '1px solid rgba(79, 209, 197, 0.18)',
  },
  bubbleHeader: {
    fontSize: '11px',
    fontWeight: 800,
    color: '#4fd1c5',
    marginBottom: '6px',
    letterSpacing: '0.02em',
  },
  bubbleStep: { display: 'block', marginTop: '3px', color: 'rgba(255,255,255,0.82)' },
  stats: {
    display: 'flex',
    gap: '8px',
    position: 'relative',
    zIndex: 1,
    paddingTop: '14px',
    borderTop: '1px solid rgba(79, 209, 197, 0.18)',
  },
  stat: {
    flex: 1,
    textAlign: 'center',
    padding: '10px 8px',
    borderRadius: '10px',
    background: 'rgba(10, 42, 47, 0.45)',
    border: '1px solid rgba(79, 209, 197, 0.18)',
  },
  statIcon: {
    fontSize: '16px',
    marginBottom: '4px',
  },
  statNum: {
    fontSize: '20px',
    fontWeight: 800,
    color: '#ffffff',
    lineHeight: 1,
    letterSpacing: '-0.01em',
  },
  statLabel: {
    fontSize: '10px',
    color: 'rgba(255,255,255,0.70)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontWeight: 700,
    marginTop: '4px',
    fontWeight: 600,
  },
  features: {
    background: 'var(--bg-surface)',
    padding: '60px 24px',
    borderTop: '1px solid var(--border)',
  },
  featuresInner: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  featuresTitle: {
    textAlign: 'center',
    fontSize: '28px',
    fontWeight: 700,
    color: 'var(--navy)',
    marginBottom: '8px',
  },
  featuresSub: {
    textAlign: 'center',
    color: 'var(--text-secondary)',
    marginBottom: '40px',
    fontSize: '15px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
  },
  card: {
    background: '#fff',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius)',
    padding: '28px',
    boxShadow: 'var(--shadow-sm)',
    transition: 'transform 0.15s, box-shadow 0.15s',
  },
  cardIcon: {
    width: '48px',
    height: '48px',
    background: 'var(--teal-light)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    marginBottom: '16px',
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: 700,
    color: 'var(--navy)',
    marginBottom: '8px',
  },
  cardText: {
    fontSize: '13px',
    color: 'var(--text-secondary)',
    lineHeight: '1.7',
  },
};

const FEATURES = [
  { icon: '🔍', title: 'Instant Answers', text: 'Ask any question and get precise answers grounded exclusively in your uploaded documents.' },
  { icon: '📄', title: 'Source Citations', text: 'Every answer includes the exact document, page number, and highlighted excerpt it came from.' },
  { icon: '🖼️', title: 'Page Previews', text: 'View the actual PDF page image alongside the answer for full context and verification.' },
  { icon: '🔒', title: 'Secure & Private', text: 'Documents stay within your environment. Answers only from your content — zero hallucinations.' },
  { icon: '', title: 'Hybrid Search', text: 'Combines semantic vector search with BM25 keyword search for maximum recall accuracy.' },
  { icon: '🤖', title: 'Azure OpenAI', text: 'Powered by GPT-4o on Azure — enterprise-grade AI with Vision OCR for scanned documents.' },
];

export default function HomePage() {
  const scrollToChat = () => {
    document.getElementById('dash-chat-trigger')?.click();
  };

  return (
    <>
      {/* Hero */}
      <section style={s.hero}>
        <div style={s.left}>
          <div style={s.tag}>
            <span>✦</span> Powered by DeliverHealth
          </div>
          <h1 style={s.h1}>
            Welcome to the <span style={s.h1Accent}>DeliverHealth</span><br />
            Community
          </h1>
          <p style={s.desc}>
            Your ultimate source for support and resources. Our community is designed to help you get the most out of DeliverHealth and provide you with the tools and expertise you need to succeed.
          </p>
          <div style={s.ctaRow}>
            <a
              href="https://deliverhealth.status.page/"
              target="_blank"
              rel="noopener noreferrer"
              style={s.ctaSecondary}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 6px 18px rgba(29, 156, 156, 0.45), 0 1px 2px rgba(0,0,0,0.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(29, 156, 156, 0.28), 0 1px 2px rgba(0,0,0,0.05)';
              }}
            >
              <span style={{ width:8, height:8, borderRadius:'50%', background:'#4ade80', boxShadow:'0 0 0 3px rgba(74,222,128,0.3)' }} />
              Status Page
            </a>
          </div>
        </div>

        <div style={s.right}>
          <div style={s.visual}>
            <div style={s.visualGrid} />
            <div style={s.visualGlow} />

            {/* Header */}
            <div style={s.visualHeader}>
              <div style={s.visualLogo}>
                <DashMascot size={28} title="DASH" />
              </div>
              <div>
                <div style={s.visualTitle}>DASH</div>
                <div style={s.visualSub}>AI Knowledge Assistant</div>
              </div>
              <div style={s.visualStatus}>
                <span style={s.statusDot} />
                LIVE
              </div>
            </div>

            {/* Mini chat preview */}
            <div style={s.chatPreview}>
              <div style={s.bubbleUser}>How do I reset my password?</div>
              <div style={s.bubbleBot}>
                <div style={s.bubbleHeader}>Self-Service Password Reset</div>
                <span style={s.bubbleStep}>• Click <b>Forgot Password?</b> on login</span>
                <span style={s.bubbleStep}>• Enter your <b>Username</b> and <b>Client Code</b></span>
                <span style={s.bubbleStep}>• Check email for reset link (expires 2 hours)</span>
              </div>
              <div style={{ ...s.bubbleUser, opacity: 0.55 }}>How to add a user?</div>
            </div>

            {/* Stats */}
            <div style={s.stats}>
              <div style={s.stat}>
                <div style={s.statNum}>150+</div>
                <div style={s.statLabel}>Articles</div>
              </div>
              <div style={s.stat}>
                <div style={s.statNum}>&lt;3s</div>
                <div style={s.statLabel}>Response</div>
              </div>
              <div style={s.stat}>
                <div style={s.statNum}>100%</div>
                <div style={s.statLabel}>Grounded</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Support Resources */}
      <SupportResources />

    </>
  );
}


/* ═══════════════════════════════════════════════════════════════════════════
   Support Resources — modern dark-theme grid section
   ═══════════════════════════════════════════════════════════════════════════ */

const SUPPORT_RESOURCES = [
  { group: 1, title: 'eSOne Documentation',  desc: 'A collection of guides and announcements to aid users in the use of eSOne applications.', cta: 'View Guide',  url: 'https://docs.escription-one.com/',  icon: 'book' },
  { group: 1, title: 'Knowledge Base',       desc: 'The Knowledge Base contains numerous support references, created by our support professionals.', cta: 'View Guide', url: 'https://communityportal.deliverhealth.com/knowledgebase/', icon: 'bulb' },
  { group: 1, title: 'eSOne Downloads',      desc: 'Download our software and get additional information about our products.', cta: 'Explore Now', url: 'https://www.escription-one.com/Software/', icon: 'download' },
  { group: 1, title: 'Product Announcements',desc: 'Stay up-to-date with the latest releases from DeliverHealth.', cta: 'Explore Now', url: 'https://docs.escription-one.com/announcements/announcements/', icon: 'megaphone' },
  { group: 2, title: 'Password Reset',         desc: 'Instructions for password reset.', cta: 'View Guide', url: 'https://communityportal.deliverhealth.com/knowledgebase/article/KA-01015/en-us', icon: 'lock' },
  { group: 2, title: 'User Add Via InQuiry',   desc: 'A guide for how to add or remove a user using InQuiry.', cta: 'View Guide', url: 'https://communityportal.deliverhealth.com/knowledgebase/article/KA-01020/en-us', icon: 'useradd' },
  { group: 2, title: 'User Add Via InCommand', desc: 'A guide for how to add or remove a new user using InCommand.', cta: 'View Guide', url: 'https://communityportal.deliverhealth.com/knowledgebase/article/000010888/en-us', icon: 'useradd' },
];

function ResourceIcon({ name }) {
  const stroke = '#a9d8d8';
  const common = { width: 32, height: 32, viewBox: '0 0 24 24', fill: 'none', stroke, strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (name) {
    case 'book':
      return (<svg {...common}><path d="M3 5a2 2 0 0 1 2-2h5v16H5a2 2 0 0 0-2 2V5z"/><path d="M21 5a2 2 0 0 0-2-2h-5v16h5a2 2 0 0 1 2 2V5z"/><line x1="6" y1="8" x2="9" y2="8"/><line x1="6" y1="11" x2="9" y2="11"/><line x1="15" y1="8" x2="18" y2="8"/><line x1="15" y1="11" x2="18" y2="11"/></svg>);
    case 'bulb':
      return (<svg {...common}><path d="M9 18h6"/><path d="M10 21h4"/><path d="M12 2a6 6 0 0 0-4 10c1 1 1.5 2 1.5 3h5c0-1 .5-2 1.5-3a6 6 0 0 0-4-10z"/></svg>);
    case 'download':
      return (<svg {...common}><circle cx="12" cy="12" r="9"/><path d="M12 7v8"/><path d="M9 12l3 3 3-3"/></svg>);
    case 'megaphone':
      return (<svg {...common}><path d="M3 11v2a2 2 0 0 0 2 2h1l3 4V5L6 9H5a2 2 0 0 0-2 2z"/><path d="M9 7l9-4v18l-9-4"/><line x1="18" y1="11" x2="21" y2="11"/></svg>);
    case 'lock':
      return (<svg {...common}><circle cx="12" cy="12" r="9"/><path d="M9 12v-1.5a3 3 0 0 1 5-2.2"/><rect x="8" y="12" width="8" height="6" rx="1"/><path d="M16 9l1.5-1.5"/></svg>);
    case 'useradd':
      return (<svg {...common}><circle cx="10" cy="8" r="3.5"/><path d="M4 20c0-3 2.5-5 6-5s6 2 6 5"/><line x1="18" y1="6" x2="18" y2="12"/><line x1="15" y1="9" x2="21" y2="9"/></svg>);
    default: return null;
  }
}

function SupportResources() {
  const [hover, setHover] = React.useState(null);
  const styles = {
    section: {
      background: 'linear-gradient(180deg, #0a1f33 0%, #0d2843 60%, #0a1f33 100%)',
      padding: '80px 24px',
      position: 'relative',
      overflow: 'hidden',
    },
    glow: {
      position: 'absolute', top: '-40%', left: '50%', transform: 'translateX(-50%)',
      width: '900px', height: '900px',
      background: 'radial-gradient(circle, rgba(29,156,156,0.18) 0%, transparent 60%)',
      pointerEvents: 'none',
    },
    inner: { maxWidth: '1280px', margin: '0 auto', position: 'relative' },
    eyebrow: {
      display: 'inline-block',
      padding: '6px 14px',
      borderRadius: '999px',
      background: 'rgba(29,156,156,0.15)',
      color: '#7fdada',
      fontSize: '12px',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      marginBottom: '14px',
      border: '1px solid rgba(29,156,156,0.3)',
    },
    title: { fontSize: '40px', fontWeight: 800, color: '#ffffff', textAlign: 'center', marginBottom: '12px', letterSpacing: '-0.5px' },
    subtitle: { fontSize: '15px', color: '#a9d8d8', textAlign: 'center', marginBottom: '48px', opacity: 0.85 },
    headWrap: { textAlign: 'center', marginBottom: '40px' },
    row: {
      display: 'grid',
      gap: '20px',
      marginBottom: '24px',
    },
    rowFour: { gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' },
    rowThree: { gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', maxWidth: '960px', margin: '0 auto' },
    card: (isHover) => ({
      background: isHover
        ? 'linear-gradient(160deg, rgba(29,156,156,0.18) 0%, rgba(13,40,67,0.95) 100%)'
        : 'linear-gradient(160deg, rgba(255,255,255,0.04) 0%, rgba(13,40,67,0.8) 100%)',
      border: isHover ? '1px solid rgba(29,156,156,0.55)' : '1px solid rgba(255,255,255,0.08)',
      borderRadius: '20px',
      padding: '32px 24px 28px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      transition: 'all 0.3s ease',
      transform: isHover ? 'translateY(-6px)' : 'none',
      boxShadow: isHover
        ? '0 18px 40px rgba(0,0,0,0.4), 0 0 30px rgba(29,156,156,0.18)'
        : '0 4px 12px rgba(0,0,0,0.2)',
      cursor: 'pointer',
      backdropFilter: 'blur(6px)',
      textDecoration: 'none',
    }),
    iconCircle: (isHover) => ({
      width: '64px',
      height: '64px',
      borderRadius: '50%',
      background: isHover
        ? 'linear-gradient(135deg, #1d9c9c 0%, #0d7377 100%)'
        : 'linear-gradient(135deg, rgba(29,156,156,0.25) 0%, rgba(29,156,156,0.1) 100%)',
      border: '1px solid rgba(29,156,156,0.35)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '22px',
      transition: 'all 0.3s ease',
      boxShadow: isHover ? '0 6px 20px rgba(13,115,119,0.5)' : 'none',
    }),
    cardTitle: { fontSize: '18px', fontWeight: 700, color: '#ffffff', marginBottom: '12px', lineHeight: 1.25 },
    cardDesc: { fontSize: '13px', color: '#a9d8d8', lineHeight: 1.55, marginBottom: '22px', flex: 1, opacity: 0.85 },
    btn: (isHover) => ({
      padding: '10px 22px',
      borderRadius: 'var(--radius-btn)',
      background: isHover
        ? '#ffffff'
        : 'rgba(255,255,255,0.95)',
      color: isHover ? '#0d7377' : '#0a1f33',
      fontSize: '13px',
      fontWeight: 700,
      textDecoration: 'none',
      transition: 'all 0.2s',
      border: 'none',
      cursor: 'pointer',
      letterSpacing: '0.02em',
      boxShadow: isHover ? '0 6px 18px rgba(255,255,255,0.25)' : '0 2px 6px rgba(0,0,0,0.15)',
      display: 'inline-block',
    }),
  };

  const group1 = SUPPORT_RESOURCES.filter((r) => r.group === 1);
  const group2 = SUPPORT_RESOURCES.filter((r) => r.group === 2);

  const renderCard = (r, idx) => {
    const key = `${r.group}-${idx}`;
    const isHover = hover === key;
    return (
      <a
        key={key}
        href={r.url}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.card(isHover)}
        onMouseEnter={() => setHover(key)}
        onMouseLeave={() => setHover(null)}
      >
        <div style={styles.iconCircle(isHover)}>
          <ResourceIcon name={r.icon} />
        </div>
        <div style={styles.cardTitle}>{r.title}</div>
        <div style={styles.cardDesc}>{r.desc}</div>
        <span style={styles.btn(isHover)}>
          {r.cta}
        </span>
      </a>
    );
  };

  return (
    <section style={styles.section}>
      <div style={styles.glow} />
      <div style={styles.inner}>
        <div style={styles.headWrap}>
          <div style={styles.eyebrow}>Help Center</div>
          <h2 style={styles.title}>Support Resources</h2>
          <p style={styles.subtitle}>Everything you need to get the most out of DeliverHealth products</p>
        </div>

        <div style={{ ...styles.row, ...styles.rowFour }}>
          {group1.map((r, i) => renderCard(r, i))}
        </div>

        <div style={{ ...styles.row, ...styles.rowThree }}>
          {group2.map((r, i) => renderCard(r, i + 100))}
        </div>
      </div>
    </section>
  );
}
